import React, { useContext } from 'react';
import { useSelector } from '../hook-utils';
import { selectCompactView } from '../store/reducers/localSettings';

const ctx = React.createContext(false)

export function useCompactView() {
  return useContext(ctx)
}

export const UseCompactView: React.FC = (props) => {
  const compactView = useSelector(selectCompactView)
  return <ctx.Provider {...props} value={compactView} />
}
